import { render, staticRenderFns } from "./IMBANGAN.vue?vue&type=template&id=72590ae8"
import script from "./IMBANGAN.vue?vue&type=script&lang=js"
export * from "./IMBANGAN.vue?vue&type=script&lang=js"
import style0 from "./IMBANGAN.vue?vue&type=style&index=0&id=72590ae8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports